import { useLocation } from 'react-router-dom';
import { STEPS } from '../utils';
import { StepperBar, StepPill } from '../TicketImporter.styles';

export const Stepper = (): JSX.Element => {
	const { hash } = useLocation();
	const current = hash || '#1';
	const currentIdx = STEPS.findIndex((s) => s.hash === current);

	return (
		<StepperBar>
			{STEPS.map((s, i) => (
				<StepPill key={s.hash} active={s.hash === current} done={i < currentIdx}>
					<span>{i + 1}.</span>
					<span>{s.label}</span>
				</StepPill>
			))}
		</StepperBar>
	);
};
